<template>
  <div id="app">
    <headerComponent :subDomain="'Accounts'" class="accounts"></headerComponent>
    <div id="grid-parent" class="container-grid" v-if="user && !!user.signInUserSession && this.$route.name !== 'signout'">
      <sideNav :routes="app_routes" :readWrite="readWriteAccess" :admin="admin" class="accounts"></sideNav>
      <router-view/>
    </div>
    <div v-else class="auth">
      <transition name="fade">
        <router-view/>
      </transition>
    </div>
  </div>
</template>

<script>
import {store} from './store/index'
import headerComponent from '@/components/foundation/header'
import sideNav from '@/components/foundation/sidebarNav'
import _ from 'lodash'

export default {
  name: 'App',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      userAuth: '',
      app_routes: this.$router.options.routes,
      readWriteAccess: 'write',
      admin: false
    }
  },
  components: {
    headerComponent,
    sideNav
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  created () {
    store.subscribe((mutation, state) => {
      if (mutation === 'SET_AUTHENTICATED') {
        console.log('AUTHENTICATED', state.authenticated)
      }
    })
    if (_.has(store.state.userAttributes, 'wholesaler') || _.has(store.state.userGroups, 'iPro_Admin')) {
      if (_.get(store.state.userAttributes, 'wholesaler') !== null || _.has(store.state.userGroups, 'iPro_Admin')) {
        this.readWriteAccess = 'write'
      } else {
        this.readWriteAccess = 'read'
      }
    } else {
      this.readWriteAccess = 'read'
    }
    if (_.has(store.state.userGroups, 'iPro_Admin')) {
      this.admin = true
    }
  }
}
</script>

<style>
.auth{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue